/**
 * The page box, in the pixels the layout is measured in.
 *
 * Taller than the sheet it prints on, and that is what keeps one box to one sheet: the export scales the box
 * to the paper's width, and a box that then overflows the printable area is moved to a fresh one whole rather
 * than flowing on and taking a slice of the next sheet with it. A box trimmed to the sheet's own proportions
 * was tried and is worse -- the boxes flow contiguously, each sheet takes a little of the next box, and by
 * the seventh the page number has climbed a third of the way up the page.
 *
 * The bottom of every box is therefore cut, which is what the print stylesheet's -36px on `.page-bottom`
 * pays for: it lifts the footer back into what is printed.
 */
export const PAGE_HEIGHT_PDF = 1350;
export const PAGE_WIDTH_PDF = 900;
export const HEIGHT_TOLERANCE_PX = 0.5;

/** Dev switch, in localStorage so it survives a reload: the export stops right before the browser's print dialog. */
export const NO_PRINT_KEY = "NO_PRINT";
